import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3513">
      <Navbar data-id="element-3514" />
      <main data-id="element-3515">
        <ConsularAffairs data-id="element-3516" />
      </main>
      <Footer data-id="element-3517" />
      <FeedbackPopup data-id="element-3518" />
    </div>;
}